import { appLayout } from '#app/init_app_layout.svelte.ts'
import { commands } from '#app/radio'
import type { ConfirmationModalProps } from '#general/components/confirmation_modal.svelte'

export async function askConfirmation (options: ConfirmationModalProps) {
  const { default: ConfirmationModal } = await import('#general/components/confirmation_modal.svelte')
  appLayout.showChildComponent('modal', ConfirmationModal, {
    props: options,
  })
  commands.execute('modal:open')
}
